import gql from 'graphql-tag';

export const UPDATE_TOOL_FILTER = gql`
  mutation updateToolFilter($filter: ToolFilterInput!, $orderBy: [String], $pagination: ToolPaginationInput) {
    updateToolFilter(filter: $filter, orderBy: $orderBy, pagination: $pagination) @client
  }
`;
